const addRsocToAllPages = () => {
  const rsocBlock = document.getElementById('gcsa-keywords-top');
  const nextButton = document.getElementById('next-page-link');

  // moves rsoc block to the current visible page
  const moveBlockToCurrPage = () => {
    const paragraphs = document.querySelectorAll(".content-section[style='display: block;'] p:not(:empty)");

    if (paragraphs.length > 0) {
      paragraphs[0].insertAdjacentElement('afterend', rsocBlock);
    }
  };

  if (rsocBlock) {
    nextButton.addEventListener('click', moveBlockToCurrPage);

    moveBlockToCurrPage();
  }
};

window.addEventListener('load', () => {
  addRsocToAllPages();
});
